export default __webpack_public_path__ + "static/media/investing_pref_01.85cca106.png";